import env from "config/env";
import { Platform } from "react-native";
import { getStoredTenantSubdomain } from "utils/storageUtils";

const API_PATH = "/api";

export default async function getApiUrl() {
  if (Platform.OS !== "web") {
    let apiUrl = env.apiUrl;
    const storedSubdomain = await getStoredTenantSubdomain();
    // console.log("api.services", storedSubdomain);
    // console.log(apiUrl.replace("tenantSubdomain", storedSubdomain));

    return apiUrl.replace(
      "tenantSubdomain",
      storedSubdomain?.subdomain || "fanrally"
    );
  }

  // return "https://brewers.api.fanrally.com/api";
  const protocol = window.location.protocol;
  let host = window.location.host;
  // If local dev web server is running on port 19006, change API request port to 8090.
  // ie: rockies.go.fanrallydev.com:19006 (the web server API port) will get switched
  // to rockies.go.fanrallydev.com:8090 (the API server port).
  host = host.replace(":8081", ":8090");
  const parts = host.split(".");
  // First subdomain is the tenant key
  const tenant = parts[0];
  // Last two parts is the primary domain (ie: fanrally.com)
  const domain = parts[parts.length - 2] + "." + parts[parts.length - 1];
  // Add any remaining subdomain parts
  const remainingCount = parts.length - 3;
  let name = tenant;
  for (let i = 0; i < remainingCount; i++) {
    // Don't add the ".go" subdomain used in production.
    // Production API endpoint is api.fanrally.com.
    if (parts[i + 1] !== "go") name += "." + parts[i + 1];
  }
  // Add api subdomain just prior to main domain, as our API runs on this subdomain.
  name += ".api." + domain;
  const path = protocol + "//" + name + API_PATH;
  return path;
}
